<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div>
      <div class="pb-3" v-if="(mailingCommunicationID || communicationID) <= 0">
        <b-notification type="is-info is-light" has-icon aria-close-label="Close notification">
          <div>
            Please save General Information Prior to selecting the Target Audience
          </div>
        </b-notification>
      </div>
      <div v-else>
        <div v-if="showSelectedAudience === false" class="pb-3">
          <button
            @click.prevent="processHomeowners(true)"
            :disabled="hasReadonly || isReadOnly"
            class="button is-primary is-rounded"
          >
            Save
          </button>
        </div>
        <div scheduling class="notification headerColor" v-if="formData">
          <div class="box is-12">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <transition name="fade" mode="out-in" appear>
                <form @submit.prevent="handleSubmit(processHomeowners)" class="form">
                  <fieldset>
                    <div class="force-center subtitle pb-5 pt-5">
                      Would you like to send your message to all homeowners?
                    </div>
                    <div class="columns">
                      <div class="column is-12">
                        <b-field label="Send to All Recipients">
                          <b-select
                            v-model="formData.audienceType"
                            required="true"
                            :disabled="hasReadonly || isReadOnly"
                            placeholder="Select a Target Audience"
                            @input="processAudienceType(true)"
                          >
                            <option
                              v-for="option in audienceTypeList"
                              :value="option.value"
                              :key="option.value"
                            >
                              {{ option.label }}
                            </option>
                          </b-select>
                        </b-field>
                      </div>
                    </div>
                    <div v-if="showSelectedAudience === true" class="force-center subtitle pb-5">
                      <div>
                        <span class="pr-5">
                          <b-button
                            v-on:keyup.enter="showHomeowner"
                            :disabled="hasReadonly || isReadOnly"
                            type="is-primary is-small"
                            @click.prevent="showHomeowner"
                            >Add Homeowner</b-button
                          ></span
                        >
                        <span>
                          <b-button
                            v-on:keyup.enter="showUnitGroups"
                            :disabled="hasReadonly || isReadOnly"
                            type="is-primary is-small"
                            @click.prevent="showUnitGroups"
                            >Add From Group</b-button
                          ></span
                        >
                      </div>
                      <div class="column is-12 pl-3">
                        <label class="label">Selected Homeowners</label>
                        <div>
                          <div
                            :style="
                              `
                display: inline;
                `
                            "
                            class="columns"
                          >
                            <div
                              v-if="
                                recipientsSelected !== undefined &&
                                  recipientsSelected &&
                                  recipientsSelected.length === 0
                              "
                            >
                              <span style="font-style:italic">No homeowners added</span>
                            </div>
                            <div
                              class="pt-3"
                              v-for="(recipient, index) in recipientsSelected"
                              :key="index"
                              :style="{
                                verticalAlign: 'top',
                                marginLeft: '0px'
                              }"
                            >
                              <b-taglist attached v-if="index % 2 === 0">
                                <b-tag
                                  type="is-light"
                                  style="background-color: white !important;"
                                  closable
                                  @close="eraseRecipient({ recipient })"
                                  >{{ JSON.stringify(recipient) }}</b-tag
                                >
                                <b-tag
                                  v-if="recipientsSelected[index + 1]"
                                  type="is-light"
                                  style="background-color: white !important;"
                                  closable
                                  @close="eraseRecipient2(recipientsSelected[index + 1])"
                                  >{{ JSON.stringify(recipientsSelected[index + 1]) }}</b-tag
                                >
                              </b-taglist>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset>
                    <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                      <div class="field">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </fieldset>
                </form>
              </transition>
            </ValidationObserver>
          </div>

          <Modal :toggle.sync="showHomeownerModal" homeowner-modal>
            <ValidationObserver ref="form1" v-slot="{ handleSubmit }">
              <transition name="fade" mode="out-in" appear v-if="showHomeownerModal == true">
                <form @submit.prevent="handleSubmit(addHomeowner)" class="form">
                  <fieldset>
                    <div message-modal>
                      <div class="pb-4 is-size-4" v-if="unitGroupList">
                        Select Homeowners
                      </div>
                      <div class="columns box is-12">
                        <div  class="box list-content column is-12">
                          <b-field label="Search">
                            <b-input @input="filterOwnerList" v-model="filterOwnerBy" />
                          </b-field>
                          <b-table
                            :data="data"
                            :loading="loading"
                            :striped="true"
                            :sticky-header="true"
                            :checked-rows.sync="checkRowsOne"
                            checkable
                            :checkbox-position="checkboxPosition"
            
                          >
                            <template slot="empty">
                              <empty-list
                                v-if="!data || (data !== undefined && data.length === 0)"
                              />
                            </template>
                            <b-table-column
                              label="Property Group"
                              field="name"
                              sortable
                              v-slot="props"
                            >
                              <div
                                style="font-size: 13pt;"
                                v-if="props.row.data.primaryOwner.name !== undefined"
                              >
                                {{
                                  `${props.row.data.primaryOwner.name || ''} - ${props.row.data
                                    .address.addressOne || ''}`
                                }}
                              </div>
                              <div v-else>&nbsp;</div>
                            </b-table-column>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <button
                        v-if="action && action == 'addunit'"
                        type="button"
                        :disabled="loading"
                        class="button is-primary is-rounded float-right"
                        @click.prevent="addOwner"
                      >
                        Add
                      </button>
                    </div>
                  </fieldset>
                  <fieldset>
                    <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                      <div class="field">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </fieldset>
                </form>
              </transition>
            </ValidationObserver>
          </Modal>

          <Modal :toggle.sync="showUnitGroupUnitModal">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <transition name="fade" mode="out-in" appear v-if="showUnitGroupUnitModal === true">
                <form @submit.prevent="handleSubmit(addUnitFromUnitGroupUnit)" class="form">
                  <fieldset>
                    <div message-modal>
                      <div class="pb-5 is-size-4" v-if="unitGroupList">
                        Select Property Group
                      </div>
                      <div class="columns box is-12">
                        <div class="box list-content column is-12">
                          <b-field label="Search">
                            <b-input @input="filterUnitGroupList" v-model="filterBy" />
                          </b-field>
                          <b-table
                            :data="unitGroupList"
                            :loading="loading"
                            :striped="true"
                            :sticky-header="true"
                            :checked-rows.sync="checkedRows"
                            checkable
                            :checkbox-position="checkboxPosition"
                          >
                            <template slot="empty">
                              <empty-list
                                v-if="
                                  !unitGroupList ||
                                    (unitGroupList !== undefined && unitGroupList.length === 0)
                                "
                              />
                            </template>
                            <b-table-column
                              label="Property Group"
                              field="name"
                              sortable
                              v-slot="props"
                              ><div style="font-size: 13pt;" v-if="props.row.name !== undefined">
                                {{
                                  `${props.row.name || ''} - (${
                                    props.row.unitGroupUnits !== undefined &&
                                    props.row.unitGroupUnits
                                      ? props.row.unitGroupUnits.length
                                      : 0
                                  } recipients)`
                                }}
                              </div>
                            </b-table-column>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <div class="column is-12">
                      <button
                        v-if="action && action == 'addunitgroupunit'"
                        type="button"
                        :disabled="loading"
                        class="button is-primary is-rounded float-right"
                        @click.prevent="addUnitGroupUnitOwner"
                      >
                        Add
                      </button>
                    </div>
                  </fieldset>
                  <fieldset>
                    <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                      <div class="field">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </fieldset>
                </form>
              </transition>
            </ValidationObserver>
          </Modal>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
//import _get from 'lodash/get'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import { data } from './keys/data'
import { methods } from './keys/methods'
import Modal from '@/components/Modal'
import EmptyList from '@/components/EmptyList'

export default {
  name: 'TargetAudienceCommunication',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly,
    Modal,
    EmptyList
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'mailingType',
        'mailMessage',
        'emailMessage',
        'emailMessageSubject',
        'mailingCommunicationID',
        'selectedDeliveryOwnerIDs',
        'selectedDeliveryOwners',
        'communicationDescription',
        'isColor',
        'isFullDuplex',
        'deliveryDate',
        'hasReadonly'
      ])
    })
  },

  async mounted() {
    this.loading = true

    this.reload()

    //const hoaID = _get(this, ['$store', 'getters', 'user/hoaIDInteger'], null)

    await this.loadHomeownerOwnerList()

    this.ownerIdsSelected = this.selectedDeliveryOwnerIDs

    if (
      this.ownerIdsSelected !== undefined &&
      this.ownerIdsSelected &&
      this.selectedDeliveryOwners !== undefined &&
      this.selectedDeliveryOwners === 'selected-owners'
    ) {
      this.showSelectedAudience = true
      this.formData.audienceType = 'No'
    } else {
      console.debug('all-owners')
      this.showSelectedAudience = false
      this.formData.audienceType = 'Yes'
    }

    if (this.fullList && this.ownerIdsSelected && this.ownerIdsSelected.length > 0) {
      Array.from(this.ownerIdsSelected).forEach(ownerID => {
        if (ownerID) {
          const tempOwner = this.fullList.filter(owner => {
            try {
              if (owner.value === ownerID) {
                return owner.label
              }
            } catch (x) {
              console.error(x)
            }
          })

          if (
            this.recipientsSelected !== undefined &&
            this.recipientsSelected &&
            tempOwner[0] !== undefined &&
            tempOwner[0] &&
            tempOwner[0].label
          ) {
            this.recipientsSelected.push(tempOwner[0].label)
          }
        }
      })

      if (
        this.recipientsSelected !== undefined &&
        this.recipientsSelected &&
        this.recipientsSelected.length > 0
      ) {
        this.$store
          .dispatch('communication/saveDeliveryOwners', {
            selectedDeliveryOwners: this.recipientsSelected
          })
          .then(() => {
            this.$store.dispatch('communication/saveDeliveryOwnerIDs', {
              selectedDeliveryOwnerIDs: this.ownerIdsSelected
            })
          })
      }
    }

    this.loading = false
  },

  watch: {
    hoaId() {
      this.reload()
    }
  },

  methods,

  i18n: {
    messages: {
      en: {
        workOrderUpdate: { title: 'Target Audiences' }
      }
    }
  }
}
</script>

<style lang="scss">
#update-work-order .my-grid-class {
  height: 400px;
}

#update-work-order tbody {
  min-height: 100px !important;
  overflow: auto !important;
}
</style>
